// extracted by mini-css-extract-plugin
export default {"wrap":"KF-z","fullWidth":"LF-z","hideOnDesktop":"MF-z","content":"NF-z","hasOpenedNav":"OF-z","crumbsList":"PF-z","dropdownsWrap":"QF-z"};